import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '@base/environments/environment';
import { QRDropdown } from '@base/src/app/models/qr-dropdown.model';
import * as moment from 'moment';
import { AgentModel } from 'src/app/models/agent.model';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { TableHeader } from 'src/app/models/tableheader.model';
import { RrhhDeleteDocumentService } from 'src/app/services/rrhh/rrhh-delete-document.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-rrhh-archives-form',
  templateUrl: './rrhh-archives-form.component.html',
  styleUrls: ['./rrhh-archives-form.component.scss'],
})
export class RrhhArchivesFormComponent implements OnInit {
  @Input() data: AgentModel | undefined;
  @Input() user:
    | { agencyId: number; loggedUser: string; isUy: boolean }
    | undefined;
  @Input() documentTypes: { id: number; type: string }[] = [];

  @Output() validStep: EventEmitter<boolean> = new EventEmitter<boolean>();

  isArgAndDo =
    environment.node === Constants.TENANT_ID_AR ||
    environment.node === Constants.TENANT_ID_DO;
  NODE = environment.node;
  NODE_DO = Constants.TENANT_ID_DO;
  NODE_AR = Constants.TENANT_ID_AR;

  buttonAddFile: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar archivos',
    icon: Constants.ICONS.PLUS,
  };

  kebabButtonConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.KEBAB,
    iconOnly: true,
  };

  dropdownDocumentTypes: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: [],
  };

  filesList: any[] = [];

  tableHeaderFiles: TableHeader[] = [
    {
      id: 'files',
      text: 'Archivo',
      percentageWidth: 43,
    },
    {
      id: 'type',
      text: 'Tipo',
      percentageWidth: 50,
    },
  ];

  fileErrorMessage = 'Seleccione un archivo';

  errors: any = {
    file: false,
  };

  allowedFormats = [
    // Documentos de Word
    // 'application/msword',
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

    // Documentos de PDF
    'application/pdf',

    // Archivos de texto
    // 'text/plain',

    // Archivos de hoja de cálculo
    // 'application/vnd.ms-excel',
    // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

    // // Imágenes
    // 'image/jpeg',
    // 'image/jpg',
    // 'image/png',
  ];

  constructor(
    public utilsService: UtilsService,
    private readonly deleteDocumentService: RrhhDeleteDocumentService,
    private readonly snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    if (!this.isArgAndDo) {
      this.tableHeaderFiles = [
        {
          id: 'files',
          text: 'Archivo',
          percentageWidth: 40,
        },
        {
          id: 'date',
          text: 'Fecha',
          percentageWidth: 26,
        },
        {
          id: 'user',
          text: 'Usuario',
          percentageWidth: 26,
        },
        {
          id: 'actions',
          text: '',
          percentageWidth: 7,
        },
      ];
    }

    if (this.documentTypes.length > 0 && this.isArgAndDo) {
      this.formatDocumentTypes(this.documentTypes);
    }
    if (this.data?.filesList) {
      this.filesList = [...this.data.filesList];
    } else if (this.data?.documents && this.data?.id) {
      this.formatFiles();
    }

    this.validateStep();
  }

  formatDocumentTypes(data: { id: number; type: string }[]): void {
    data.forEach((e: { id: number; type: string }) => {
      this.dropdownDocumentTypes.options.push(e.type);
    });
  }

  formatFiles() {
    // TODO: fix anys

    this.data?.documents.forEach((e: any) => {
      if (e.status && e.status != 2) {
        const TYPE: { id: number; type: string } | undefined =
          this.documentTypes.find((item) => e.documentType === item.id);

        const item = this.isArgAndDo
          ? {
              file: e.name,
              date: e.createdDate,
              user: e.createdBy,
              path: e.path,
              name: e.name,
              type: TYPE?.type,
            }
          : {
              file: e.name,
              date: e.createdDate,
              user: e.createdBy,
              path: e.path,
              name: e.name,
            };
        this.filesList.push(item);
      }
    });
    if (this.filesList.length > 0) this.errors.file = false;
    this.validateStep();
  }

  addFile($event: any) {
    if ($event?.target?.files) {
      for (const key in $event.target.files) {
        const file = $event.target.files[key];

        // Validacion tipo de archivo
        if (file && !this.allowedFormats.includes(file.type)) {
          this.errors.file = true;
          this.fileErrorMessage = 'Formato de archivo no soportado.';
          // Validacion tamaño de archivo
        } else if (file && file.size >= 5000000) {
          this.fileErrorMessage = 'Tamaño de archivo superior a 5 MB.';
          this.errors.file = true;
        } else {
          const reader = new FileReader();

          reader.onloadend = () => {
            const result = reader.result as string;
            const itemfile = this.isArgAndDo
              ? {
                  file: file.name,
                  date: moment().format('YYYY-MM-DD'),
                  user: this.user?.loggedUser ?? '',
                  path: result ?? null,
                  name: file.name,
                  type: '',
                }
              : {
                  file: file.name,
                  date: moment().format('YYYY-MM-DD'),
                  user: this.user?.loggedUser ?? '',
                  path: result ?? null,
                  name: file.name,
                };

            const item = this.isArgAndDo
              ? {
                  path: result,
                  name: file.name,
                  documentType: 0,
                }
              : {
                  path: result,
                  name: file.name,
                };

            this.data?.documents.push(item);

            this.filesList.push(itemfile);
            this.filesList = [...this.filesList];
            if (this.data) this.data.filesList = this.filesList;
            this.errors.file = false;
            this.validateStep();
          };

          if (file) reader.readAsDataURL(file);
        }
      }
    }
    this.validateStep();
  }

  changeDocumentType($event: string, fileName: string) {
    const ITEM_FILE_LIST:
      | {
          file: string;
          date: string;
          user: string;
          path: string | null;
          name: string;
          type: string | undefined;
        }
      | undefined = this.filesList.find((e) => e.name === fileName);
    if (ITEM_FILE_LIST) {
      ITEM_FILE_LIST.type = $event;
    }

    const ITEM_DOCUMENTS: {
      path: string;
      name: string;
      documentType: number;
      status?: number;
    } = this.data?.documents.find((e) => e.name === fileName && e.status !== 2);
    const TYPE:
      | {
          id: number;
          type: string;
        }
      | undefined = this.documentTypes.find((e) => e.type === $event);

    if (ITEM_DOCUMENTS && TYPE) {
      ITEM_DOCUMENTS.documentType = TYPE.id;
    }
    this.validateStep();
  }

  downloadFile(path: string | null, name: string) {
    if (path && name) {
      const link = document.createElement('a');
      link.href = path;
      link.download = name;
      link.click();
      link.remove();
    }
  }

  deleteFile(name: string) {
    if (name) {
      const item = this.filesList.find((e: any) => e.name == name);
      if (item) {
        const index = this.filesList.indexOf(item);
        this.filesList.splice(index, 1);
        this.snackbarService.openSnackBar(
          'Documento eliminado correctamente',
          ''
        );
      }
      if (this.data?.filesList) {
        const ITEM_3 = this.data.filesList.find((e: any) => e.name == name);
        if (ITEM_3) {
          const INDEX: number = this.data.filesList.indexOf(ITEM_3);
          this.data.filesList.splice(INDEX, 1);
        }
      }

      // TODO: FIX ANYS
      const ITEM_2 = this.data?.documents.find((e: any) => e.name == name);
      if (ITEM_2?.id) {
        const dto = {
          id: ITEM_2.id,
          loggedUser: this.user?.loggedUser,
        };
        this.deleteDocumentService.post(dto, '').then((response: any) => {
          if (response?.body?.code == 200) {
            this.snackbarService.openSnackBar(response.body.message, '');
          }
        });
      }
      if (ITEM_2) {
        const INDEX_2: number | undefined =
          this.data?.documents.indexOf(ITEM_2);
        if (INDEX_2 || INDEX_2 === 0) {
          this.data?.documents.splice(INDEX_2, 1);
        }
      }
    }
    this.validateStep();
  }

  validateStep() {
    const HAS_DOCUMENTS = this.data && this.data.documents.length > 0;
    const HAS_VALID_FILES = this.filesList?.length > 0;

    const HAS_INVALID_TYPE = this.isArgAndDo
      ? this.filesList?.some(
          (file) =>
            file.type === '' || file.type === null || file.type === undefined
        )
      : false;

    if (this.NODE === this.NODE_DO) {
      if (!HAS_VALID_FILES) {
        this.validStep.emit(true);
        return;
      }

      if (HAS_VALID_FILES && !HAS_INVALID_TYPE) {
        this.validStep.emit(true);
        return;
      }

      this.validStep.emit(false);
      return;
    }

    let result = false;

    if ((HAS_DOCUMENTS || HAS_VALID_FILES) && !HAS_INVALID_TYPE) {
      result = true;
    }

    this.validStep.emit(result);
  }
}
